var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/modules/es.symbol.to-primitive.js